import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import FindADealer from '../../../3_Organisms/FindADealer/FindADealer'
import { languageController } from '../../../../controllers/language/languageController'
import Checkbox from '../../../1_Atoms/Forms/Checkbox/Checkbox'
import Form from '../../../2_Molecules/Form/Form'
import Button from '../../../1_Atoms/Button/Button'
import { useForm } from '../../../../hooks/useForm'
import parse from 'html-react-parser';
import { handleRequest } from '../../../../utils/httpRequest'
import { getEndpointUrl } from '../../../../utils/endPoints'
import pidController from '../../../../controllers/pidController'

function FindDealerStep_TiE({
  handleNextStep,
  currentVehicleData,
  desiredVehicleData,
  userInformation,
  source,
  language
}) {
  const [dealerData, setDealerData] = useState(null)
  const [formError, setFormError] = useState(null)

  const { handleSubmit, data, errors, setData } = useForm({
    initState: {
      optin: false,
    },
    // Send the form data if validated
    onSubmit: async () => {
      try {
        const submissionData = {
          dealerId: Number(dealerData?.dealer_code),
          OptIn: optin,
          pid: pidController.getPid('tradeInValue'),
          source: source,
          language: language,
        }

        // Add currentVehicleData data if passed
        if (currentVehicleData) {
          submissionData.TradeIn_Id = Number(currentVehicleData.tradeInId);
          submissionData.TradeIn_Year = Number(currentVehicleData.tradeInYear);
          submissionData.TradeIn_Make = currentVehicleData.tradeInMake;
          submissionData.TradeIn_Model = currentVehicleData.tradeInModel;
          submissionData.TradeIn_Trim = currentVehicleData.tradeInTrim;
          submissionData.TradeIn_odometer = Number(currentVehicleData.tradeInOdometer);
          submissionData.TradeIn_PriceLow = currentVehicleData.tradeInPriceLow;
          submissionData.TradeIn_PriceHigh = currentVehicleData.tradeInPriceHigh;
          submissionData.vehicleSearch = currentVehicleData.searchTerm;
        }

        // Add userInformation data if passed
        if (userInformation) {
          submissionData.firstname = userInformation.firstname;
          submissionData.lastname = userInformation.lastname;
          submissionData.email = userInformation.email;
          submissionData.PurchaseTimeFrame = userInformation.purchaseDate;
        }

        // Add userInformation data if passed
        if (desiredVehicleData) {
          submissionData.Buy_Id = desiredVehicleData.id;
          submissionData.Buy_Year = desiredVehicleData.year;
          submissionData.Buy_Make = 'Mazda'; // Always set as 'Mazda'
          submissionData.Buy_Model = desiredVehicleData.model;
          submissionData.Buy_Trim = undefined; // Always blank or not defined
          submissionData.Buy_Price = desiredVehicleData.msrp;
        }

        const res = await handleRequest('post', getEndpointUrl('cbb'), submissionData);

        if (res.Success) {
          handleNextStep({ dealerData: dealerData })
        } else {
          setFormError(res.state ? res.state : res.Errors[0])
        }
      } catch (err) {
        console.log(err)
      }
    },
  })

  const { optin } = data;

  // Only render FindADealer when a different vahicle is selected in step 2.
  const MemoFindADealer = useMemo(() => {
    return (
      <FindADealer
        isStepRenderType={true}
        onSelectDealer={(data) => setDealerData(data.dealer)}
        isEVonly={desiredVehicleData.isEV ? true : false}
      />
    );
  }, [desiredVehicleData]);

  return (
    <div className="mz-find-dealer-step-tie">
      <div className="mz-find-dealer-step-tie__dealer">
        <h5 className="mz-find-dealer-step-tie__title">{languageController.getCopy('tradeInEstimator', 'step4Title')}</h5>
        {MemoFindADealer}
      </div>
      <div className="mz-find-dealer-step-tie__form mz-container">
        <div className="grid-inner-content">
          <Form
            onSubmit={handleSubmit}
            isDark={false}
            noValidate={true}
            errorMessage={formError}
          >
            <div className="mz-find-dealer-step-tie__email-encouragement label label--tight">
              {languageController.getCopy('global', 'emailEncouragement')}
            </div>
            <Checkbox
              name="optin"
              checked={optin}
              onChange={(e) => setData({ optin: !optin })}
              label={parse(languageController.getCopy('global', 'subscribeLegal'))}
            />
            <Button
              type="submit"
              className="mz-btn--primary mz-btn--red"
              label={languageController.getCopy('tradeInEstimator', 'step4Submit')}
              disabled={(dealerData === null)}
            />
          </Form>
        </div>
      </div>
    </div>
  )
}

FindDealerStep_TiE.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  currentVehicleData: PropTypes.object,
  desiredVehicleData: PropTypes.object,
  userInformation: PropTypes.object,
  source: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
}

export default FindDealerStep_TiE